/**
 *  All api related to currencies
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchCurrencies(params = {}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCurrencies',
    () => source.cancel('fetchCurrencies: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'currencies',
      method: 'get',
      params,
      cancelToken: source.token,
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      currencies: data.currencies,
      cacheChecksum: _.get(cacheChecksum, 'currenciesValue'),
    }))
}
